var init = require('init');

init.then(function (init) {

	require('../sass/normalize.scss');

	require('@material/layout-grid/mdc-layout-grid.scss');
	require('@material/dialog/mdc-dialog.scss');
	require('@material/card/mdc-card.scss');
	require('@material/menu/mdc-menu.scss');
	require('@material/tab/mdc-tab.scss');
	require('@material/chips/mdc-chips.scss');
	require('@material/linear-progress/mdc-linear-progress.scss');
	require('@material/fab/mdc-fab.scss');
	require('@material/list/mdc-list.scss');
	require('@material/select/mdc-select.scss');
	require('@material/switch/mdc-switch.scss');
	require('@material/radio/mdc-radio.scss');
	require('parsleyjs/src/parsley.css');

	require('@os/mdc/button.scss');
	require('@os/mdc/layout-grid.scss');
	require('@os/mdc/text-field.scss');
	require('@os/mdc/radio.scss');
	require('@os/mdc/switch.scss');
	require('@os/mdc/dialog.scss');
	require('@os/list/list.scss');
	require('@os/typography/typography.scss');
	require('@os/helper/helper.scss');

	require('../sass/plain-overlay/plain-overlay.scss');
	require('../sass/parsleyjs/parsleyjs.scss');
	require('../sass/certificate/certificate.scss');
	require('../sass/certificate-header/certificate-header.scss');
	require('../sass/certificate-toolbar/certificate-toolbar.scss');
	require('../sass/certificate-company/certificate-company.scss');
	require('../sass/certificate-company-description/certificate-company-description.scss');
	require('../sass/certificate-description-card/certificate-description-card.scss');
	require('../sass/certificate-info-card/certificate-info-card.scss');
	require('../sass/certificate-detail-rating/certificate-detail-rating.scss');
	require('../sass/certificate-review-search/certificate-review-search.scss');
	require('../sass/certificate-search-sort-row/certificate-search-sort-row.scss');
	require('../sass/certificate-review/certificate-review.scss');
	require('../sass/certificate-about-os/certificate-about-os.scss');
	require('../sass/certificate-company-enroll/certificate-company-enroll.scss');
	require('../sass/certificate-modal-control-review/certificate-modal-control-review.scss');
	require('../sass/certificate-modal-survey-flag/certificate-modal-survey-flag.scss');
	require('../sass/certificate-modal-customer-contact/certificate-modal-customer-contact.scss');
	require('../sass/certificate-review-empty/certificate-review-empty.scss');
	require('../sass/certificate-review-search-sort-bar/certificate-review-search-sort-bar.scss');

	var templateBody = require('../view/certificate.hbs');
	var templateSurveyList = require('../view/certificate-review.hbs');
	var templateSurveyListEmpty = require('../view/certificate-review-empty.hbs');
	var templateSearchPill = require('../view/certificate-search-pill.hbs');
	var templateCollaboratorMenu = require('../view/certificate-collaborator-menu.hbs');
	var templateCompanyMenu = require('../view/certificate-company-menu.hbs');
	var templateModalControlReview = require('../view/certificate-modal-control-review.hbs');
	var templateModalContact = require('../view/certificate-modal-contact.hbs');
	var templateModalSurveyFlag = require('../view/certificate-modal-survey-flag.hbs');
	var templateProfessionalActivityMenu = require('../view/certificate-professional-activity-menu.hbs');
	var templateProfessionalActivityStats = require('../view/certificate-detail-rating-activity-stats.hbs');

	define(['jquery', 'js-cookie', '@material/ripple', 'moment',
		'i18next', 'jquery-match-height', '@material/menu',
		'@material/textfield', '@material/tab', '@material/tab-indicator', '@material/select',
		'@os/header', '@os/footer', '@os/survey-request', '@material/dialog', '@os/form-data', '@os/single-survey', 'numeral', 'parsleyjs',
		'@os/google-recaptcha', '@os/hubspot-form'
	], function ($, jsCookie, mdcRipple, moment, i18next,
		jqueryMatchHeight, mdcMenu, mdcTextField, mdcTab, mdcTabIndicator, mdcSelect, header, footer, surveyRequest, mdcDialog, formData, singleSurvey, numeral, parsley,
		googleRecaptcha, hubspotForm
	) {

		jQuery = $;
		require('jquery-plainoverlay');
		require('parsleyjs/src/extra/validator/words.js');
		var resizeTimer;
		var pillCounter = 0;
		var pillIds = [];
		var searchParameter = {};
		var collaboratorId = null;
		var groupId = null;
		var companyId = null;
		var singleSurveyId = null;
		var recaptcha;

		moment.locale(jsCookie.get('locale').toLowerCase());

		// load a locale
		numeral.register('locale', 'fr-fr', {
			delimiters: {
				thousands: ' ',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				return number === 1 ? 'er' : 'ème';
			},
			currency: {
				symbol: '€'
			}
		});
		numeral.register('locale', 'en-ca', {
			delimiters: {
				thousands: ' ',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				return number === 1 ? 'st' : ((number === 2) ? 'nd' : ((number === 3) ? 'rd' : 'th'));
			},
			currency: {
				symbol: '$'
			}
		});
		numeral.register('locale', 'nl-be', {
			delimiters: {
				thousands: ' ',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			currency: {
				symbol: '€'
			}
		});

		// switch between locales
		numeral.locale(jsCookie.get('locale').toLowerCase());

		$(function () {

			$("a.fusion-link").on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				$("#awb-oc-504").addClass("awb-show");
			});

			$(".off-canvas-close").on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				$("#awb-oc-504").removeClass("awb-show");
			});

			$(document).keypress(function (e) {
				if (e.key == 'Escape') {
					e.preventDefault();
					e.stopPropagation();
				}
			});

			$.fn.isInViewport = function () {
				var elementTop = $(this).offset().top;
				var elementBottom = elementTop + $(this).outerHeight() + 50;
				var viewportTop = $(window).scrollTop();
				var viewportBottom = viewportTop + $(window).height();
				return elementBottom > viewportTop && elementTop < viewportBottom;
			};


			if (/certificate\/c\/([0-9]+)/.test(window.location.href)) {
				collaboratorId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
				/*window.location.href = '/certificate.php?collaborator_id=' + collaboratorId;
				return false;*/
			} else if (/certificate\/g\/([0-9]+)/.test(window.location.href)) {
				groupId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
			} else {
				let url = new URL(window.location.href);
				let path = url.pathname;
				let params = new URLSearchParams(url.search);

				companyId = path.substring(path.lastIndexOf('/') + 1);
				singleSurveyId = params.get("survey_id");
			}


			$(document).on('click', '[data-action="toggle-hours"]', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).parents(".info-list").find(".certificate-info-card-hours").toggle();
			});

			$(document).on('click', '[data-action="toggle-social"]', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).parents(".info-list").find(".certificate-info-social-media").toggle();
			});

			$(document).on('click', '.toolbar-link', function (e) {
				e.preventDefault();
				e.stopPropagation();
				scrolling = false;
				var offset = 40;
				if ($(this).attr('href')) {
					$('html,body').animate({
						'scrollTop': ($($(this).attr("href")).offset().top - offset)
					}, 1000, function () {
						scrolling = true;
					});
				}
			});

			$(document).on('click', '.mdc-tab', function (e) {
				e.preventDefault();
			});

			$(document).on('click', function (e) {
				if (!$(e.target).parents(".os-menu").length) {
					$('.os-menu').each(function () {
						$(this).parents('.col').find('.certificate-review-search-menu').removeClass('active');
						$(this).hide();
					});
				}
			});

			$(document).on('click', '.description-read-more', function (event) {
				var thisEl = $(this)
				if ($(this).parents('.description-wrapper').find('.description')[0].hasAttribute('style')) {
					var el = $(this).parents('.description-wrapper').find('.description'),
						curHeight = el.height(),
						autoHeight = el.css('height', '9em').height();
					el.height(curHeight).animate({
						height: autoHeight
					}, 500, function () {
						$(this).parents('.description-wrapper').find('.description').removeAttr("style");
					});
				} else {
					var el = $(this).parents('.description-wrapper').find('.description'),
						curHeight = el.height(),
						autoHeight = el.css('height', 'auto').height();
					el.height(curHeight).animate({
						height: autoHeight
					}, 500);
				}
				window.setTimeout(function () {
					thisEl.toggleClass('background');
				}, 100);
				if ($(this).parents('.description-wrapper').find('.description').hasClass('show-more')) {
					$(this).find('.read-more-text').html(i18next.t('certificate-description:read_less'));
				} else {
					$(this).find('.read-more-text').html(i18next.t('certificate-description:read_more'));

				}
			})


			/*==============================================*
			 * Search filters operations						*
			 *==============================================*/
			$(document).on('click', '.certificate-review-search-filter-smiley', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).hasClass('clickable')) {
					$(this).toggleClass('active');
					updateSearchCriteria();
				}
			});

			$(document).on('click', '.collaborator-search-menu, .more-filter-search-menu', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).hasClass('clickable')) {

					$('.os-menu').each(function () {
						$(this).parents('.col').find('.certificate-review-search-menu').removeClass('active');
						$(this).parents('.col').find('.professional-activites-dropdown').removeClass('active');
						$(this).hide();
					});

					$(this).toggleClass('active');

					$(this).next('.os-menu').toggle();
					if ($(this).hasClass('collaborator-search-menu')) {
						$('#collaborator_filter_textfield').focus();
					}
				}
			});

			$(document).on('click', '.professional-activites-dropdown', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).hasClass('clickable')) {

					$('.os-menu').each(function () {
						$(this).parents('.col').find('.certificate-review-search-menu').removeClass('active');
						$(this).parents('.col').find('.certificate-detail-rating-clickable').removeClass('active');
						$(this).hide();
					});

					$(this).toggleClass('active');

					if ($(this).hasClass('active')) {
						$(this).next('.os-menu').show();
					} else {
						$(this).next('.os-menu').hide();
					}
				}
			});
			$(document).on('keyup', '#company_filter_textfield', function () {
				$.ajax({
					type: 'GET',
					url: '/api/certificate/company',
					data: {
						group_id: groupId,
						search: $(this).val()
					},
					dataType: 'json'
				}).done(function (data) {
					$('#certificate_company_menu').empty().append(templateCompanyMenu(data));
				});
			});
			$(document).on('keyup', '#collaborator_filter_textfield', function () {
				$.ajax({
					type: 'GET',
					url: '/api/certificate/collaborator',
					data: {
						company_id: companyId,
						search: $(this).val()
					},
					dataType: 'json'
				}).done(function (data) {
					$('#certificate_collaborator_menu').empty().append(templateCollaboratorMenu(data));
				});
			});

			$(document).on('click', '.certificate-review-search-card .os-menu .mdc-list .mdc-list-item.clickable', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).toggleClass('active');
				if ($(this).find('.mdc-switch').length) {
					if ($(this).find('.mdc-switch input').is(':checked')) {
						$(this).find('.mdc-switch input').prop('checked', false);
						$(this).find('.mdc-switch').removeClass('mdc-switch--checked');
					} else {
						$(this).find('.mdc-switch input').prop('checked', true);
						$(this).find('.mdc-switch').addClass('mdc-switch--checked');
					}
				}

				if ($(this).hasClass('active')) {
					showSearchFilterPill($(this).data("pill-id"), $(this).data("filter-type"), $(this).data("filter-label"), $(this).data("filter-value"));
				} else {
					removeSearchFilterPill($(this).data("pill-id"), $(this).data("filter-type"));
				}
				updateSearchCriteria();
			});

			$(document).on('click', '#filter_holder .mdc-chip', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var listItemId = $(this).attr("id").split('-')[1];
				var listItemType = $(this).attr("id").split('-')[0];
				var listItem = "";
				switch (listItemType) {
					case 'professional_activity':
						list = ".professional-activity-menu";
						break;
					case 'collaborator':
						list = ".collaborator-menu";
						break;
					case 'company':
						list = ".company-menu";
						break;

					default:
						break;
				}
				var listItem = $(list + ' .mdc-list .mdc-list-item[data-pill-id="' + listItemId + '"]');

				removeSearchFilterPill(listItemId, listItemType);

				listItem.toggleClass('active');
				if (listItem.find('.mdc-switch').length) {
					if (listItem.find('.mdc-switch input').is(':checked')) {
						listItem.find('.mdc-switch input').prop('checked', false);
						listItem.find('.mdc-switch').removeClass('mdc-switch--checked');
					} else {
						listItem.find('.mdc-switch input').prop('checked', true);
						listItem.find('.mdc-switch').addClass('mdc-switch--checked');
					}
				}
				updateSearchCriteria();
			});

			/*==============================================*
			 * 	Detailed Rating operations							*
			 *==============================================*/

			$(document).on('click', '.certificate-detail-rating-clickable', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).hasClass('clickable')) {

					$('.os-menu').each(function () {
						$(this).hide();
					});

					$(this).toggleClass('active');

					if ($(this).hasClass('active')) {
						$(this).next('.os-menu').show();
					} else {
						$(this).next('.os-menu').hide();
					}
				}
			});

			$(document).on('click', '#detail_rating_professional_activities_menu li', function (e) {
				e.preventDefault();
				e.stopPropagation();

				var professionalActivityId = $(this).data("id");
				var questionId = $(this).data("question-id");

				if (!$(this).hasClass('active')) {
					$('.professional-activity-item').each(function () {
						$(this).removeClass('active');
					});

					i = pillIds.length;
					while (i--) {
						var pillId = pillIds[i].split('-');
						removeSearchFilterPill(pillId[1], pillId[0]);
					}

					$(this).toggleClass('active');

					if ($(this).attr("data-id") == -1) {
						updateSearchCriteria();
					} else {
						$('.certificate-review-search-card .professional-activity-menu .mdc-list .mdc-list-item[data-pill-id="' + professionalActivityId + '"]').click();
					}

					$('#professional_activity_menu_text').html($(this).children('span').html());

					$.ajax({
						type: 'GET',
						url: '/api/certificate/statistics',
						data: {
							company_id: companyId,
							collaborator_id: collaboratorId,
							group_id: groupId,
							question_id: questionId,
							professional_activity_id: professionalActivityId,
							locale: jsCookie.get('locale')
						},
						dataType: 'json'
					}).done(function (data) {
						test = { "hide_questions": professionalActivityId == -1, ...data };
						$('#professional_activity_stats_container').empty().append(templateProfessionalActivityStats(test));
						$('#professional_activity_stats_container .date-label').each(function () {
							$(this).html(moment.utc($(this).html()).format('MMMM YYYY'));
						});
						animateGageSection('#professional_activity_stats_container');
					});

					$('#detailed_rating .professional-activity-dropdown-container .os-menu').hide();
					$('#detailed_rating .certificate-detail-rating-clickable').removeClass('active');
				}
			});


			/*==============================================*
			 * 	Search operations							*
			 *==============================================*/

			$(document).on('click', 'button[data-action="more-review"]', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).attr('disabled', 'disabled');

				listSurvey(companyId, collaboratorId, "add", "", $('#review_list').data("position"));
			});


			/*==============================================*
			 * 	Single survey operations							*
			 *==============================================*/
			$(document).on('click', '[data-action="toggle-single-review-detail"]', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).parents("#modalSingleSurvey").find(".review-detail-rating").toggle();
				$(this).parents("#modalSingleSurvey").find(".review-detail-rating").toggleClass("open");
				if ($(this).parents("#modalSingleSurvey").find(".review-detail-rating").hasClass("open")) {
					$(this).find(".dynamic-button-text").html(($(window).width() > 479) ? i18next.t('single-survey:button.show_less') : i18next.t('single-survey:button.show_less_small'));
					animateGageSection('#modalSingleSurvey .review-detail-rating');
				} else {
					$(this).find(".dynamic-button-text").html(($(window).width() > 479) ? i18next.t('single-survey:button.show_more') : i18next.t('single-survey:button.show_more_small'));
				}
				$(this).parents("#modalSingleSurvey").find(".chevron").toggleClass("fa-chevron-down").toggleClass("fa-chevron-up");
				$(this).parents("#modalSingleSurvey").find(".ref-number-toggler").toggleClass("invisible");
			});

			$(document).on('click', '#modalSingleSurvey [data-action="survey-flag"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				$('#singleSurveyClose').click();
			});

			$(document).on('click', '#modalSingleSurvey [data-action="review-contact"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				$('#singleSurveyClose').click();
			});


			/*==============================================*
			 * Review box operations 						*
			 *==============================================*/
			$(document).on('click', '[data-action="toggle-review-detail"]', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).parents("div.mdc-card").find(".review-detail-rating").toggle();
				$(this).parents("div.mdc-card").find(".review-detail-rating").toggleClass("open");
				if ($(this).parents("div.mdc-card").find(".review-detail-rating").hasClass("open")) {
					$(this).find(".dynamic-button-text").html(($(window).width() > 479) ? i18next.t('certificate-review:button.show_less') : i18next.t('certificate-review:button.show_less_small'));
					var surveyId = $(this).parents('.review-item').data('survey-id');
					animateGageSection('.review-item[data-survey-id="' + surveyId + '"] .review-detail-rating');
				} else {
					$(this).find(".dynamic-button-text").html(($(window).width() > 479) ? i18next.t('certificate-review:button.show_more') : i18next.t('certificate-review:button.show_more_small'));
				}
				$(this).find(".chevron").toggleClass("fa-chevron-down").toggleClass("fa-chevron-up");
				$(this).parents("div.mdc-card").find(".ref-number-toggler").toggleClass("invisible");
			});

			$(document).on('click', 'a[data-action="show-control-dialog"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($('#dialog_control').length > 0) {
					$('#dialog_control').remove();
				}
				var data = {
					external: (($(this).hasClass('external')) ? true : false),
					controlled: (($(this).hasClass('controlled')) ? true : false)
				};
				$("#page-content").append(templateModalControlReview(data));

				dialog = new mdcDialog.MDCDialog(document.querySelector('#dialog_control'));
				if ($('#dialog_control').hasClass('static')) {
					dialog.deregisterDocumentKeydownHandler();
				}
				dialog.show();
			});

			$(document).on('click', '.ref-number-toggler', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).next(".ref-number").toggleClass("invisible");
				$(this).hide();
			});





			/*==============================================*
			 * Contact operations							*
			 *==============================================*/

			$(document).on('click', '[data-action="review-contact"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				$.ajax({
					type: 'GET',
					url: '/api/certificate/contact',
					data: {
						survey_id: $(this).data("survey-id")
					},
					dataType: 'json'
				}).done(function (data) {

					if ($('#dialog_contact').length > 0) {
						$('#dialog_contact').remove();
					}
					$("#page-content").append(templateModalContact(data));

					$('#dialog_contact .mdc-text-field').each(function (index, object) {
						mdcTextField.MDCTextField.attachTo(object);
					});

					$('#dialog_contact .mdc-button').each(function (index, object) {
						mdcRipple.MDCRipple.attachTo(object);
					});

					$('#dialog_contact .mdc-ripple-upgraded').each(function (index, object) {
						mdcRipple.MDCRipple.attachTo(object);
					});

					dialog = new mdcDialog.MDCDialog(document.querySelector('#dialog_contact'));
					$('#dialog_contact form[name="contact_form"]').parsley({
						excluded: 'input[type=button],input[type=submit],input[type=reset],[disabled]'
					});
					googleRecaptcha.render('#dialog_contact form[name="contact_form"]');
					dialog.show();
				});
			});

			$(document).on('click', 'button[data-action="check-code"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($('#dialog_contact form[name="contact_form"]').parsley().validate({
					group: 'step1',
					force: true
				})) {
					$(this).attr('disabled', 'disabled');
					$.ajax({
						url: '/api/certificate/contact/code',
						type: 'POST',
						data: {
							code: $('#survey_contact input[name="code"]').val(),
							survey_id: $('#survey_contact input[name="survey_id"]').val()
						},
						dataType: 'json',
						context: this
					}).done(function (data) {
						$(this).hide();
						if (data.success) {
							$('#dialog_contact button[data-action="contact-send"]').show();
							$("#survey_contact .panels .panel").removeClass("os-dialog__panel--active");
							$("#survey_contact .panels .panel:eq(1)").addClass("os-dialog__panel--active");
						} else {
							$(this).parents(".mdc-dialog").addClass("mdc-dialog-alert");
							$("#survey_contact .panels .panel").removeClass("os-dialog__panel--active");
							$("#survey_contact .panels .panel:eq(5)").addClass("os-dialog__panel--active");
						}
					});
				}
			});

			$(document).on('click', 'button[data-action="contact-send"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($('#dialog_contact form[name="contact_form"]').parsley().validate({
					group: 'step2',
					force: true
				})) {
					$(this).attr('disabled', 'disabled');
					$.ajax({
						url: '/api/certificate/contact/send',
						type: 'POST',
						data: formData('#survey_contact input[name="name"]', {
							locale: jsCookie.get('locale')
						}),
						dataType: 'json',
						context: this
					}).done(function (data) {
						$(this).hide();
						$(this).parents(".mdc-dialog").addClass("mdc-dialog-alert");
						if (data.success) {
							tabIndex = 2;
						} else {
							switch (data.error) {
								case 1:
									tabIndex = 3;
									break;
								case 2:
									tabIndex = 4;
									break;
								default:
									tabIndex = 5;
									break;
							}
						}
						$('#survey_contact .panels .panel').removeClass('os-dialog__panel--active');
						$('#survey_contact .panels .panel:eq(' + tabIndex + ')').addClass('os-dialog__panel--active');
					});
				}
			});

			/*==============================================*
			 * Survey Flag operations						*
			 *==============================================*/

			$(document).on('click', '[data-action="survey-flag"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				$.ajax({
					type: 'POST',
					url: '/api/certificate/survey/flag',
					data: {
						survey_id: $(this).data("survey-id")
					},
					dataType: 'json'
				}).done(function (data) {

					if ($('#dialog_survey_flag').length > 0) {
						$('#dialog_survey_flag').remove();
					}
					$("#page-content").append(templateModalSurveyFlag(data));

					$('#dialog_survey_flag .mdc-text-field').each(function (index, object) {
						mdcTextField.MDCTextField.attachTo(object);
					});

					$('#dialog_survey_flag .mdc-button').each(function (index, object) {
						mdcRipple.MDCRipple.attachTo(object);
					});

					$('#dialog_survey_flag .mdc-ripple-upgraded').each(function (index, object) {
						mdcRipple.MDCRipple.attachTo(object);
					});

					dialog = new mdcDialog.MDCDialog(document.querySelector('#dialog_survey_flag'));
					$('form[name="survey_flag_form"]').parsley({
						excluded: 'input[type=button],input[type=submit],input[type=reset],[disabled]'
					});
					googleRecaptcha.render('form[name="survey_flag_form"]');
					dialog.show();
				});
			});

			$(document).on('click', 'button[data-action="survey-flag-next-step"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				switch ($(this).data("step")) {
					case 1:
						//Validate form
						if ($('form[name="survey_flag_form"]').parsley().validate()) {
							$(this).attr('disabled', 'disabled');
							$.ajax({
								url: '/api/certificate/survey/flag/send',
								type: 'POST',
								data: formData('#survey_flag_form input[name="first_name"]', {
									locale: jsCookie.get('locale')
								}),
								dataType: 'json',
								context: this
							}).done(function (data) {
								$(this).hide();
								$(this).parents(".mdc-dialog").addClass("mdc-dialog-alert");
								if (data.success) {
									tabIndex = 1;
								} else {
									if (data.error.duplicate) {
										$("#error_message_other").hide();
									} else {
										$("#error_message_process").hide();
									}
									tabIndex = 2;
								}
								$("#survey_flag_form .panels .panel").removeClass("os-dialog__panel--active");
								$("#survey_flag_form .panels .panel:eq(" + tabIndex + ")").addClass("os-dialog__panel--active");
							});
						}
						break;
				}
			});


			$(document).on('click', 'a[data-action="show-order-menu"]', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var menu = new mdcMenu.MDCMenu($(this).next('.mdc-menu')[0]);
				menu.show();
			});

			$(document).on('click', 'a[data-action="show-order-menu"] + .mdc-menu .mdc-list-item', function (e) {
				$('#order_by_label').html($(this).html());
				$('form[name="search_form"] input[name="sort"]').val($(this).data('value'));
				updateSearchCriteria();
			});

			$(document).on('click', '.certificate-review-search-sort-bar__sort-direction-icon', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).hasClass('clickable')) {
					$(this).find('svg').hide();
					switch ($(this).data('filter-value')) {
						case "DESC":
							//Going asc...
							$(this).data('filter-value', 'ASC');
							$(this).find('svg:first-child').css('display', 'inline-block');
							break;
						case "ASC":
							//Going desc...
							$(this).data('filter-value', 'DESC');
							$(this).find('svg:last-child').css('display', 'inline-block');
							break;
					}
					$('form[name="search_form"] input[name="sort_direction"]').val($(this).data('filter-value'));
					updateSearchCriteria();
				}
			});

			$(document).on('click touchstart', function (e) {
				if (!$(e.target).parents(".os-menu").length) {
					$('.os-menu').each(function () {
						$(this).parents('.col').find('.certificate-review-search-menu').removeClass('active');
						$(this).parents('.col').find('.certificate-detail-rating-clickable').removeClass('active');
						$(this).hide();
					});
				}
			});

			$(document).on('click', '.review-positive-icon', function (event) {
				if ($('.certificate-review-search-filter-smiley.clickable.neutral').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.neutral').removeClass('active');
				}
				if ($('.certificate-review-search-filter-smiley.clickable.bad').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.bad').removeClass('active');
				}
				$('.certificate-review-search-filter-smiley.clickable.good').addClass('active');
				$('html').animate({
					scrollTop: $("#company_review_search_card").offset().top
				}, 1000, function () {
					updateSearchCriteria()
				});
			});

			$(document).on('click', '.review-neutral-icon', function (event) {
				if ($('.certificate-review-search-filter-smiley.clickable.good').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.good').removeClass('active');
				}
				if ($('.certificate-review-search-filter-smiley.clickable.bad').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.bad').removeClass('active');
				}
				$('.certificate-review-search-filter-smiley.clickable.neutral').addClass('active');
				$('html').animate({
					scrollTop: $("#company_review_search_card").offset().top
				}, 1000, function () {
					updateSearchCriteria();
				});
			});

			$(document).on('click', '.review-negative-icon', function (event) {
				if ($('.certificate-review-search-filter-smiley.clickable.good').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.good').removeClass('active');
				}
				if ($('.certificate-review-search-filter-smiley.clickable.neutral').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.neutral').removeClass('active');
				}
				$('.certificate-review-search-filter-smiley.clickable.bad').addClass('active');
				$('html').animate({
					scrollTop: $("#company_review_search_card").offset().top
				}, 1000, function () {
					updateSearchCriteria()
				});
			});

			$(document).on('click', '.review-all-icon', function (event) {
				if ($('.certificate-review-search-filter-smiley.clickable.good').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.good').removeClass('active');
				}
				if ($('.certificate-review-search-filter-smiley.clickable.neutral').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.neutral').removeClass('active');
				}
				if ($('.certificate-review-search-filter-smiley.clickable.bad').hasClass('active')) {
					$('.certificate-review-search-filter-smiley.clickable.bad').removeClass('active');
				}
				$('html').animate({
					scrollTop: $("#company_review_search_card").offset().top
				}, 2000, function () {
					updateSearchCriteria()
				});
			});

			$(window).on('scroll', function () {
				if ($('.certificate-detail-rating .panels .panel.active').isInViewport()) {
					animateGageSection('.certificate-detail-rating .panels .panel.active');
				}
			});

			$(document).on('click', '.trimmed-read-more', function (event) {
				event.preventDefault();
				$(this).siblings('.trimmed-ellipsis').toggle();
				$(this).siblings('.trimmed-full-text').toggle();
				$(this).hide();
			});

			new Promise(function (resolve, reject) {
				showLoadingOverlay();
				$.ajax({
					type: 'GET',
					url: '/api/certificate',
					dataType: 'json',
					data: {
						company_id: companyId,
						collaborator_id: collaboratorId,
						group_id: groupId,
						locale: jsCookie.get('locale'),
						init: true
					}
				}).done(function (data) {
					if ("error" in data) {
						console.log("Error");

						hideLoadingOverlay();
						window.location.href = '/' + window.location.pathname.split('/')[1] + '/certificate/error';
					} else {
						var locale = jsCookie.get('locale');
						var localeLang = locale.split('-');
						var lang = localeLang[0];

						data.languageBasedOffUrl = lang;

						$('#page-content').append(templateBody(data));
						$('#detail_rating_professional_activities_menu li:first-child').click();

header.init();

						surveyRequest.init();
						hubspotForm.init();

						$(".trimmed-full-text").hide();
						$(".trimmed-read-more").html(i18next.t('certificate-review:read_more'));

						$('.review-item__modified-comment-tooltip').hide();
						$('.mdc-text-field').each(function (index, value) {
							mdcTextField.MDCTextField.attachTo($(this)[0]);
						});

						$('.mdc-select').each(function (index, object) {
							select = new mdcSelect.MDCSelect(object);
						});

						$('.mdc-button').each(function (index, object) {
							mdcRipple.MDCRipple.attachTo(object);
						});

						$('.mdc-ripple-upgraded').each(function (index, value) {
							mdcRipple.MDCRipple.attachTo($('.mdc-ripple-upgraded')[index]);
						});

						//Update 'since' dates with moment library
						$('body .moment_date').each(function () {
							$(this).html(moment.utc($(this).html()).fromNow());
						});
						$('body .survey-modified-date').each(function () {
							$(this).html(moment.utc($(this).html()).format('D MMMM YYYY'));
						});
						$('body .date-label').each(function () {
							$(this).html(moment.utc($(this).html()).format('MMMM YYYY'));
						});

						$('#review_list').data("position", data.review.length);
						$('.toggle_modified_tooltip').on('click', function () {
							if ($(window).width() < $(this).parents('.review-item').find('.review-item__modified-comment-tooltip').outerWidth() + 10) {
								$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').css('max-width', '95%');
								$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').css({
									left: '2.5%',
									top: '1em'
								});
							} else {
								$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').css({
									top: '-2em',
									left: '.5em'
								});
							}
							$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').toggle();
						});
						if ($(window).width() > 839) {
							$.fn.matchHeight._apply('.certificate-same-height-card', {
								property: 'min-height'
							});
						}
						if (data.company.description && data.company.description.length < 400) {
							$('.description-read-more').hide();
							$('.company-description-card .text-box.description-wrapper .description').addClass('normal');
						}
						if (window.location.hash.substr(1) == "review") {
							$('.certificate-review-search-card-subheader button[data-action="survey-request"]').trigger('click');
						}
						if (singleSurveyId) {
							singleSurvey.init(singleSurveyId, companyId);
						}

						hideLoadingOverlay();
						resolve(data);
					}
				}).fail(function (xhr, error) {
					reject(error);
				});
			});
		});

		function animateGageSection(target) {
			animateGage(target);
			animateQuestions(target);
		}

		function animateQuestions(target) {
			$(target + ' .question:not(.animated)').each(function () {
				$(this).addClass('animated');
				$(this).find('.mdc-linear-progress__bar').css({
					'-webkit-transform': 'scaleX(' + $(this).find('.mdc-linear-progress__bar').data('value') + ')',
					'-moz-transform': 'scaleX(' + $(this).find('.mdc-linear-progress__bar').data('value') + ')',
					'-ms-transform': 'scaleX(' + $(this).find('.mdc-linear-progress__bar').data('value') + ')',
					'-o-transform': 'scaleX(' + $(this).find('.mdc-linear-progress__bar').data('value') + ')',
					'transform': 'scaleX(' + $(this).find('.mdc-linear-progress__bar').data('value') + ')'
				});


				$(this).find('.notation').each(function () {
					var notation = $.trim($(this).text());

					// A question with no answer shows "ND" rather than a score; counting up to it
					// would resolve to NaN and overwrite the label.
					if (isNaN(parseFloat(notation))) {
						return;
					}

					$(this).animate({
						counter: notation
					}, {
						duration: 1000,
						step: function (now) {
							var number = numeral(now);
							$(this).text(number.format('0.0'));
						}
					});
				});
			});
		}

		function animateGage(target) {
			$(target + ' .knob.new-knob').each(function () {
				$(this).removeClass('new-knob');
				$(this).find('clipPath').closest('svg').attr('viewBox', $($(this).find('clipPath').closest('svg').find('use').attr('xlink:href')).find('svg').attr('viewBox'));
				$(this).find('clipPath').animate({
					percentage: $(this).data("percentage")
				}, {
					duration: 1000,
					step: function (now, fx) {
						$(this).find('path')[0].setAttribute('d', calculatePath(now / 100, $(this).closest('svg').attr('viewBox').split(" ")[2]));
					}
				});
			});
		}

		function calculatePath(percent, size) {

			var path = '';

			path += 'M ' + translateQuadrant([0, 0], size).join(' ');
			path += ' L ' + translateQuadrant([0, 1], size).join(' ');
			if (percent < 0.125) {
				path += ' L ' + translateQuadrant([Math.tan(percent * -360 * Math.PI / 180), 1], size).join(' ');
			} else {
				path += ' L ' + translateQuadrant([-1, 1], size).join(' ');
				if (percent < 0.375) {
					if (percent < 0.25) {
						path += ' L ' + translateQuadrant([-1, 1 - Math.tan((0.125 - percent) * -360 * Math.PI / 180)], size).join(' ');
					} else {
						path += ' L ' + translateQuadrant([-1, -Math.tan((0.25 - percent) * -360 * Math.PI / 180)], size).join(' ');
					}
				} else {
					path += ' L ' + translateQuadrant([-1, -1], size).join(' ');
					if (percent < 0.625) {
						if (percent < 0.5) {
							path += ' L ' + translateQuadrant([Math.tan((0.375 - percent) * -360 * Math.PI / 180) - 1, -1], size).join(' ');
						} else {
							path += ' L ' + translateQuadrant([Math.tan((0.5 - percent) * -360 * Math.PI / 180), -1], size).join(' ');
						}
					} else {
						path += ' L ' + translateQuadrant([1, -1], size).join(' ');
						if (percent < 0.875) {
							if (percent < 0.75) {
								path += ' L ' + translateQuadrant([1, Math.tan((0.625 - percent) * -360 * Math.PI / 180) - 1], size).join(' ');
							} else {
								path += ' L ' + translateQuadrant([1, Math.tan((0.75 - percent) * -360 * Math.PI / 180)], size).join(' ');
							}
						} else {
							path += ' L ' + translateQuadrant([1, 1], size).join(' ');
							if (percent <= 1) {
								path += ' L ' + translateQuadrant([1 - Math.tan((0.875 - percent) * -360 * Math.PI / 180), 1], size).join(' ');
							}
						}
					}
				}
			}

			return path;
		}

		function translateQuadrant(coordinate, size) {
			return [(coordinate[0] + 1) * (size / 2), (size - ((coordinate[1] + 1) * (size / 2)))];
		}

		function listSurvey(companyId, collaboratorId, action, type, position, professionalActivity) {
			if (typeof type === 'undefined') {
				type = "";
			}
			if (typeof position === 'undefined') {
				position = "";
			}

			showLoadingOverlay();
			$.ajax({
				type: "POST",
				url: "/api/certificate/survey",
				data: {
					company_id: companyId,
					collaborator_id: collaboratorId,
					group_id: groupId,
					professional_activity: professionalActivity,
					type: type,
					position: position,
					sort: $('form[name="search_form"] input[name="sort"]').val(),
					sort_order: $('form[name="search_form"] input[name="sort_direction"]').val(),
					locale: jsCookie.get('locale'),
					filter: JSON.stringify(searchParameter)
				},
				dataType: "json"
			}).done(function (data) {
				switch (action) {
					case "load":
						if (data.total > 0) {
							$("#review_list").removeClass('no-result').empty().append(templateSurveyList(data));
							$('.order-by-filter-column').show();
							$('.certificate-review-search-sort-bar__total-number').html(data.overall_total);
						} else {
							$("#review_list").addClass('no-result').empty().append(templateSurveyListEmpty(data));
							$('.order-by-filter-column').hide();
							$('.certificate-review-search-sort-bar__total-number').html("0");
						}
						$("#review_list").data("position", data.total);
						break;
					case "add":
						$('.new-review-item').removeClass('new-review-item');
						$("#review_list").append(templateSurveyList(data));
						$("#review_list").data("position", (parseInt($("#review_list").data("position")) + parseInt(data.total)));
						break;
				}

				$(".trimmed-full-text").hide();
				$(".trimmed-read-more").html(i18next.t('certificate-review:read_more'));

				$("#review_list").data("type", data.type);
				$('.review-item__modified-comment-tooltip').hide();
				//Update 'since' dates with moment library
				$('#review_list .new-review-item .moment_date').each(function () {
					$(this).html(moment.utc($(this).html()).fromNow());
				});
				$('body .survey-modified-date').each(function () {
					$(this).html(moment.utc($(this).html()).format('D MMMM YYYY'));
				});
				$('.toggle_modified_tooltip').on('click', function () {
					if ($(window).width() < $(this).parents('.review-item').find('.review-item__modified-comment-tooltip').outerWidth() + 10) {
						$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').css('max-width', '95%');
						$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').css({
							left: '2.5%',
							top: '1em'
						});
					} else {
						$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').css({
							top: '-2em',
							left: '.5em'
						});
					}
					$(this).parents('.review-item').find('.review-item__modified-comment-tooltip').toggle();
				});
				$('#review_list .new-review-item .date-label').each(function () {
					$(this).html(moment.utc($(this).html()).format('MMMM YYYY'));
				});

				if (data.more_result === false) {
					$('button[data-action="more-review"]').hide();
				} else {
					$('button[data-action="more-review"]').show();
					$('button[data-action="more-review"]').removeAttr('disabled');
				}
				$('#good_stats').html(data.average.positive_review);
				$('#neutral_stats').html(data.average.neutral_review);
				$('#bad_stats').html(data.average.negative_review);

				loading = false;
				hideLoadingOverlay();
			});
		}

		function showSearchFilterPill(pillId, type, label, value) {
			var data = {
				pill_id: `${type}-${pillId}`,
				type: {
					collaborator: ((type == 'collaborator') ? true : false),
					company: ((type == 'company') ? true : false),
					criteria: ((type == 'criteria') ? true : false),
					professionalActivity: ((type == 'professional_activity') ? true : false)
				},
				criteria: {
					contact: ((type == 'criteria' && value == 'contact') ? true : false),
					control: ((type == 'criteria' && value == 'control') ? true : false),
					media: ((type == 'criteria' && value == 'media') ? true : false),
				},
				label: label,
				value: value
			};

			if (pillCounter == 0) {
				$("#filter_holder").show();
			}
			pillCounter++;
			pillIds.push(`${type}-${pillId}`);
			$("#filter_holder").append(templateSearchPill(data));
		}

		function removeSearchFilterPill(pillId, type) {
			$(`#${type}-${pillId}`).remove();
			pillCounter--;
			pillIds.splice(pillIds.indexOf(`${type}-${pillId}`), 1);
			if (pillCounter == 0) {
				$("#filter_holder").empty().hide();
			}
		}

		function updateSearchCriteria() {

			var rating = {};
			var collaborator = {};
			var professionalActivity = {};
			var criteria = {};
			var company = {};

			//Rating type
			$(".certificate-review-search-filter-smiley.active").each(function (index) {
				rating[index] = $(this).data('filter-value');
			});

			//Collaborator
			$(".collaborator-menu .mdc-list-item.active").each(function (index) {
				collaborator[index] = $(this).data('filter-value');
			});
			//Company
			$(".company-menu .mdc-list-item.active").each(function (index) {
				company[index] = $(this).data('filter-value');
			});
			//Professional Activity
			$(".professional-activity-menu .mdc-list-item.active").each(function (index) {
				professionalActivity[index] = $(this).data('filter-value');
			});

			//Criteria
			$(".more-filter-menu .mdc-list-item.active").each(function (index) {
				criteria[index] = $(this).data('filter-value');
			});

			searchParameter['rating'] = rating;
			searchParameter['collaborator'] = collaborator;
			searchParameter['company'] = company;
			searchParameter['professional_activity'] = professionalActivity;
			searchParameter['criteria'] = criteria;
			searchParameter['sort'] = $('form[name="search_form"] input[name="sort"]').val();
			searchParameter['sort_order'] = $('form[name="search_form"] input[name="sort_direction"]').val();

			listSurvey(companyId, collaboratorId, "load", "", "0", professionalActivity)
		}

		function enableSearchFilters() {

			//Enable rating filters
			$('.company-review-search-filter-smiley').addClass('clickable');

			//Enable collaborator and more filters menu
			$('.collaborator-search-menu').addClass('clickable');
			$('.more-filter-search-menu').addClass('clickable');

			//Enable pill (if any)
			$('.filter-pill .pill-discard').addClass('clickable');

			//Enable order component
			$('#sort_select').removeAttr('disabled');
			$('.company-review-search-filter-sort-direction').addClass('clickable');

			//Enable Survey Request round (+) button

		}

		function disableSearchFilters() {

			//Disable rating filters
			$('.company-review-search-filter-smiley').removeClass('clickable');

			//Disable collaborator and more filters menu
			$('.collaborator-search-menu').removeClass('clickable');
			$('.more-filter-search-menu').removeClass('clickable');

			//Disable pill (if any)
			$('.filter-pill .pill-discard').removeClass('clickable');

			//Disable order component
			$('#sort_select').attr('disabled', 'disabled');
			$('.company-review-search-filter-sort-direction').removeClass('clickable');

			//Disable Survey Request round (+) button

		}

		function showLoadingOverlay(target) {
			if (typeof target === 'undefined') {
				target = 'body';
			}
			$(target).plainOverlay('show', {
				progress: function () {
					return $('<div class="plain-overlay__icon"></div>');
				}
			});
		}

		function hideLoadingOverlay(target) {
			if (typeof target === 'undefined') {
				target = 'body';
			}
			$(target).plainOverlay('hide');
		}
	});
});